import { useContext } from 'react';
import { LocaleContext } from './LocaleContext.js';
import { getValidLangOrFallback, sprintf } from './utils.js';

/**
 * A hook that takes as parameter the translations for a component and returns
 * a function that can be used to translate individual strings.
 *
 * @param translations `LocaleTranslations` JSON object containing translations
 * @param langOverride `Lang | undefined`  optional language code override
 * @returns function for translating individual strings
 */
function useTranslations(translations, langOverride) {
    const { lang: langContext } = useContext(LocaleContext);
    // Ensure that the lang is valid even if Lang typing is not honored.
    const lang = getValidLangOrFallback(langOverride !== null && langOverride !== void 0 ? langOverride : langContext);
    return (key, ...replacements) => {
        if (translations[lang][key]) {
            return sprintf(translations[lang][key], ...replacements);
        }
        else {
            throw new Error(`Missing translation for ${key} in language ${lang}!`);
        }
    };
}

export { useTranslations };
//# sourceMappingURL=hooks.js.map
